export const apuracaoReviewFormConfig = [
	{
		fields: [
			{
				name: "reviewDetails",
				label: "",
				type: "textarea",
				placeholder: "Descreva os detalhes...",
				defaultValue: "",
				rows: 2,
				columns: 12
			}
		]
	}
];